import { useQrGenerator } from './useQrGenerator';

export const useQrGeneratorAssets = () => {
  const { downloadAssets, isLoading } = useQrGenerator();

  return { download: downloadAssets, isLoading }
}